import React from 'react';

export const PageNotFound = () => <div className="text-white">Page not found</div>;
